module.exports = "<div class=\"page-home\">\n  <display-system uoid=\"{{vm.uoid}}\"></display-system>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/pages/home/home.html
// module id = 671
// module chunks = 0